// Range options for the Trends page's page-level selector.
//
// Trends charts daily rollups — one point per day — so the history pages'
// 1d/3d spans would render a single dot. These are the rollup-appropriate
// ones. `1y` is the API's 365-day cap (GET /rollups clamps `days` there).
//
// These live in their own module rather than beside TrendRangeSelector so that
// file exports only its component. Strictly, only TREND_RANGE_DAYS forced the
// split — a typed object literal is not exempt under the lint config's
// `allowConstantExport`, whereas the `as const` array is (which is why
// ViewToggle can keep VIEW_MODES beside it). Moving all three keeps the
// component module single-purpose rather than exempt-by-accident, and keeps
// React Fast Refresh working for it.
export const TREND_RANGE_KEYS = ['7d', '30d', '90d', '1y'] as const;
export type TrendRange = (typeof TREND_RANGE_KEYS)[number];

export const TREND_RANGE_DAYS: Record<TrendRange, number> = {
  '7d': 7,
  '30d': 30,
  '90d': 90,
  '1y': 365,
};
